import React from "react";
import './preview_product_img.scss';

import { Icon} from '@ui-kit';

const { VITE_PRODUCTS_URL } = import.meta.env;

const PreviewProductImg = ({id, pathToPreview, alt, title, classNames=''}) => {
    const classes= ['info__avatar', ...classNames.split(' ')];
    
    return (
        <div className={classes.join(' ')}>
            <Icon
                src={`${VITE_PRODUCTS_URL}/${pathToPreview}`}
                title={title}
                alt={`${alt}-${id}`}
            />
        </div>
    )
}

export default PreviewProductImg;